__webpack_require__.p = "/data-structures-and-algorithm/";